import React, { useState } from 'react';
import { Tabs } from 'antd';
import ChemicalMaterialList from './ChemicalMaterialList';
import ChemicalMaterialChangeHistory from './ChemicalMaterialChangeHistory';

const ChemicalMaterialMain: React.FC = () => {
  const [activeKey, setActiveKey] = useState('list');
  return (
    <Tabs activeKey={activeKey} onChange={setActiveKey} items={[
      { key: 'list', label: 'Liste / Ekle', children: <ChemicalMaterialList /> },
      { key: 'history', label: 'Hareket Geçmişi', children: <ChemicalMaterialChangeHistory /> },
    ]} />
  );
};

export default ChemicalMaterialMain; 